import React from 'react'
import { useTranslation } from 'react-i18next'
import { LegalCard } from '@/features/legal/components/Elements'

export const PrivacyPolicyContainer = () => {
  const { t } = useTranslation()

  return <LegalCard title={t('privacy_policy')}>{null}</LegalCard>
}
